export default [
  {
    path: 'warranty-installment',
    name: 'list-debt-installment-warranty',
    component: () =>
      import(
        /* webpackChunkName: "list-debt-installment-warranty" */ './list/index.vue'
      ),
    meta: {
      title: 'Công nợ trả góp bảo hành - Clickbuy',
    },
  },
];
